import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Gauge } from 'lucide-react';
import { MigrationTab } from './MigrationTab';
import { CompletenessGridTab } from './CompletenessGridTab';

type TabId = 'migration' | 'grid';

const TABS: { id: TabId; label: string }[] = [
  { id: 'migration', label: 'Migration' },
  { id: 'grid', label: 'Completeness grid' },
];

export function DataOpsPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const initial = (searchParams.get('tab') as TabId) || 'migration';
  const [tab, setTabState] = useState<TabId>(initial);

  const setTab = (t: TabId) => {
    setTabState(t);
    const next = new URLSearchParams(searchParams);
    next.set('tab', t);
    setSearchParams(next, { replace: true });
  };

  return (
    <div>
      <div className="flex items-center gap-2 mb-4">
        <Gauge className="w-5 h-5 text-gray-700 dark:text-gray-300" />
        <div>
          <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100">
            Data Ops Console
          </h2>
          <p className="text-xs text-gray-400 mt-0.5">
            Fleet-wide ingestion oversight. Migration backfill progress and daily completeness.
          </p>
        </div>
      </div>

      <div className="flex gap-1 mb-4 border-b border-gray-200 dark:border-gray-800">
        {TABS.map((t) => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            className={`px-3 py-2 text-sm font-medium -mb-px border-b-2 transition-colors ${
              tab === t.id
                ? 'border-[#FFC712] text-gray-900 dark:text-gray-100'
                : 'border-transparent text-gray-500 hover:text-gray-700 dark:hover:text-gray-300'
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {tab === 'migration' ? <MigrationTab /> : <CompletenessGridTab />}
    </div>
  );
}
